import cn from 'classnames';
import { rm } from 'utils';
import styles from './offer.scss';
import { Button } from 'components/Button';
import { FooterItemProps } from 'components/Footer/themes/PP/footer';

interface Props extends FooterItemProps {
  className?: string;
}

export const Offer = ({ className, onNavClick }: Props) => (
  <div className={cn(styles.offer, className)}>
    <Button
      className={styles.button}
      onClick={() => onNavClick(rm('footer_offer_link'))}
      href={rm('footer_offer_link')}
    >
      {rm('footer_offer_button')}
    </Button>
  </div>
);
